import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

function PageTransition({ children }) {
  const location = useLocation();
  const [displayLocation, setDisplayLocation] = useState(location);
  const [stage, setStage] = useState('enter');

  useEffect(() => {
    if (location.pathname !== displayLocation.pathname) {
      setStage('exit');
    }
  }, [location, displayLocation]);

  const handleAnimationEnd = () => {
    if (stage === 'exit') {
      setDisplayLocation(location);
      setStage('enter');
      window.scrollTo({ top: 0, behavior: 'auto' });
    }
  };

  return (
    <div
      className={`page-transition page-transition-${stage}`}
      onAnimationEnd={handleAnimationEnd}
    >
      {typeof children === 'function' ? children(displayLocation) : children}
    </div>
  );
}

export default PageTransition;
